import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, Injector, Type } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class DynamicComponentProvider {
    private componentRefs: ComponentRef<any>[] = [];

    constructor(
      private injector: Injector,
      private resolver: ComponentFactoryResolver,
      private appRef: ApplicationRef
    ) {
    }

    public injectComponent<T>(component: Type<T>, propertySetter?: (type: T) => void): HTMLDivElement {
        const compFactory = this.resolver.resolveComponentFactory(component);
        const compRef = compFactory.create(this.injector);
        if (propertySetter) {
            propertySetter(compRef.instance);
        }
        this.appRef.attachView(compRef.hostView);
        this.componentRefs.push(compRef);
        const div = document.createElement('div');
        div.appendChild(compRef.location.nativeElement);
        return div;
    }

    public destroyAll(): void {
        this.componentRefs.forEach(ref => {
            this.appRef.detachView(ref.hostView);
            ref.destroy();
        });
        this.componentRefs = [];
    }

    public getComponentCount(): number {
        return this.componentRefs.length;
    }
}
